import { subscribe } from '../api/klaviyo'

class KlaviyoForm extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.emailInput = this.querySelector('input[name="email"]')
    this.inputWrapper = this.querySelector('.js-email-input-wrapper')
    this.successWrapper = this.querySelector('.js-email-success')
    this.errorWrapper = this.querySelector('.js-email-error')
    this.submit = this.querySelector('button[type="submit"]')
    this.form.addEventListener('submit', this.onSubmit)
  }

  destroy = () => {
    this.form.removeEventListener('submit', this.onSubmit)
  }

  onSubmit = (event) => {
    event.preventDefault()

    this.submit.classList.add('opacity-50')
    this.submit.classList.add('cursor-pointer')
    this.submit.disabled = true
    this.successWrapper.classList.add('hidden')
    this.errorWrapper.classList.add('hidden')
    this.inputWrapper.classList.remove('has-error')

    subscribe(KLAVIYO_LIST_ID, this.emailInput.value)
      .then((response) => {
        if (!response.success) {
          throw new Error(response.errors[0])
        }

        this.submit.classList.remove('opacity-50')
        this.submit.classList.remove('cursor-pointer')
        this.submit.disabled = false

        this.emailInput.classList.add('hidden')
        this.submit.classList.add('hidden')
        this.errorWrapper.classList.add('hidden')
        this.successWrapper.classList.remove('hidden')
      })
      .catch((error) => {
        console.error(error);
        this.submit.classList.remove('opacity-50')
        this.submit.classList.remove('cursor-pointer')
        this.submit.disabled = false
        this.inputWrapper.classList.add('has-error')

        this.errorWrapper.classList.remove('hidden')
        this.errorWrapper.innerHTML = error
      })
  }
}

if (!customElements.get('klaviyo-form'))
  customElements.define('klaviyo-form', KlaviyoForm)
